import axios from "axios";
import {detailServicesPath, estimateServicesPath, ordersServicesPath} from "../../Constants";
import FileService from "../orders/orders/customer/FileService";

const restUrl = ordersServicesPath + '/organizations/files/upload'
const restUrlDetail = detailServicesPath + '/organizations/details-order'
const restUrlModelEstimate = estimateServicesPath + '/files/upload'

export default class FileUploadController {
    static async uploadRequestsCuttingFiles(files, requestCuttingId) {
        return await axios.post(restUrl + '/detail-files/for-basis' + "?requestsCuttingId=" + requestCuttingId,
            FileService.getFormDataArray(files, "files"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }


    static async uploadRequestsCuttingFilesPro100(files, requestsCuttingId) {
        return await axios.post(restUrlDetail + '/import/pro100?requestsCuttingId=' + requestsCuttingId,
            FileService.getFormData(files[0]), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });

    }

    static async uploadModelEstimateFiles(files) {
        return await axios.post(restUrlModelEstimate + '/exel-detail-model-files',
            FileService.getFormDataArray(files, "files"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async uploadModelEstimateFilesKDT(files, modelSeries, materialName) {
        return await axios.post(restUrlDetail + '/model/import/kdt?modelSeries=' + modelSeries + "&materialName=" + materialName,
            FileService.getFormDataArray(files, "file"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }
}